if (!customElements.get('luzz-cannon-model')) {
  customElements.define('luzz-cannon-model', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-cannon-model-map]').textContent);
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.onReady = () => this.apply(this.dataset.model);
      this.onPopState = () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const selected = this.root?.querySelector('input.product-variant-id')?.value;
        if (id && selected && id !== selected) window.location.reload();
      };
      window.addEventListener('popstate', this.onPopState);
      if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = webvista.subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const data = event.data;
          if (data.sectionId !== this.dataset.section) return;
          const rendered = data.html?.querySelector('luzz-cannon-model');
          const model = rendered?.dataset.model || this.config.variants[String(data.variant?.id)];
          if (model) this.apply(model);
          this.root?.removeAttribute('aria-busy');
        });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.onReady, {once: true});
      } else {
        this.onReady();
      }
    }
    apply(model) {
      if (!['original', 'cannon2'].includes(model)) return;
      this.dataset.model = model;
      this.root?.querySelectorAll('[data-cannon-content-model]').forEach(element => {
        element.hidden = element.dataset.cannonContentModel !== model;
      });
      Object.entries(this.config.sections).forEach(([group, sections]) => {
        sections.forEach(suffix => {
          const section = document.getElementById(`shopify-section-${this.dataset.section.replace(/__main$/, '')}__${suffix}`);
          if (section) section.hidden = group !== model;
        });
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      document.removeEventListener('DOMContentLoaded', this.onReady);
      window.removeEventListener('popstate', this.onPopState);
    }
  });
}
